import { render } from "./ConfigureEmail.vue?vue&type=template&id=670567aa&scoped=true&ts=true"
import script from "./ConfigureEmail.vue?vue&type=script&lang=ts"
export * from "./ConfigureEmail.vue?vue&type=script&lang=ts"

import "./ConfigureEmail.vue?vue&type=style&index=0&id=670567aa&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670567aa"]])

export default __exports__